import { type User } from '@bliks-io/contracts';
import { EntityPickerModal, type EntityPickerCopy } from '@bliks-io/ui';
import { usePersonPickerConfig } from './hooks/usePersonPickerConfig';

export interface PersonPickerModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mode: 'single' | 'multi';
  selectedIds: string[];
  onConfirm: (ids: string[]) => void;
  excludeIds?: string[];
  onBack?: () => void;
  /** Process the picker is opened from. Drives the "for this process" bucket. */
  processId?: string;
  /** Current recording — excluded from the "for this process" bucket aggregate. */
  recordingId?: string;
  /** Per-context copy overrides (e.g. the "who else does this" framing). */
  copyOverrides?: Partial<EntityPickerCopy>;
}

export function PersonPickerModal({
  open,
  onOpenChange,
  mode,
  selectedIds,
  onConfirm,
  excludeIds,
  onBack,
  processId,
  recordingId,
  copyOverrides
}: PersonPickerModalProps) {
  const { items, isLoading, config } = usePersonPickerConfig({
    open,
    mode,
    processId,
    recordingId,
    copyOverrides
  });

  return (
    <EntityPickerModal<User>
      open={open}
      onOpenChange={onOpenChange}
      items={items}
      isLoading={isLoading}
      selectedIds={selectedIds}
      mode={mode}
      onConfirm={onConfirm}
      config={config}
      onBack={onBack}
      excludeIds={excludeIds}
    />
  );
}
